import {makeObservable, observable, action, runInAction} from 'mobx';
import { CalendarDisplayEvent } from '../types/calendar-types';
import {BookingDetail, BookingListItem} from "../model/professional/booking-model";

/**
 * Store pour gérer l'état du calendrier
 */
class CalendarStore {
  // État observable du calendrier
  @observable bookings: BookingListItem[] = [];
  @observable selectedBooking: BookingDetail | null = null;
  @observable calendarEvents: CalendarDisplayEvent[] = [];
  @observable selectedEvent: CalendarDisplayEvent | null = null;
  @observable isLoading: boolean = false

  constructor() {
    makeObservable(this);
  }

  setIsLoading(){
    this.isLoading = true
  }

  // Actions pour modifier l'état
  @action
  setBookings(bookings: BookingListItem[]) {
    this.bookings = bookings;
    this.setIsLoading()
  }

  @action
  updateAppointment(id: string, newStatus: 'confirmed' | 'cancelled' | 'completed') {
    runInAction(() => {
      this.bookings = this.bookings.map(appointment =>
          appointment.id === id ? { ...appointment, status: newStatus } : appointment
      );
    });
  }

  @action
  setSelectedBooking(booking: BookingDetail | null) {
    this.selectedBooking = booking;
  }


  @action
  setCalendarEvents(events: CalendarDisplayEvent[]) {
    this.calendarEvents = events;
  }

  @action
  setSelectedEvent(event: CalendarDisplayEvent | null) {
    this.selectedEvent = event;
  }

}

// Exporter une instance singleton du store
export const calendarStore = new CalendarStore();
